import React from 'react';
import { useTranslation } from 'react-i18next';

import { OmaLummeApp } from '../../../../omaLummeContext';
import { ManageContractsApp } from '../contractManagementContext';
import { ManageContractsCheckbox } from '../ManageContractsRadioCheckbox';
import ManageContractsAddressFields from '../ManageContractsAddressFields';

// Utils.
import { generateAddress } from '../../../../utils/address';

export const TerminateLedgerAddress: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const dispatch = ManageContractsApp.useDispatch();

  const { users } = OmaLummeApp.useState();
  const { terminateLedgerUseCurrentAddress, terminateLedgerAddress } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepTerminateLedgerAddress">
      <h3>{t('manageContracts:manageContracts.TerminateLedgerAddressTitle')}*</h3>
      <p>{t('manageContracts:manageContracts.TerminateLedgerAddressBody')}</p>

      <ManageContractsCheckbox
        radioID="TerminateLedgerUseCurrentAddress"
        onChangeFunc={(): void => {
          dispatch(['terminateLedgerUseCurrentAddress', !terminateLedgerUseCurrentAddress]);
          dispatch(['terminateLedgerAddress', { streetName: '', houseNumber: '', houseLetter: '', residence: '', zipCode: '', cityName: '' }]);
        }}
        checkedComparison={terminateLedgerUseCurrentAddress}
        label={`${t('manageContracts:manageContracts.NewAddressUseCurrentAddress')} <strong>${generateAddress(
          users.activeUser.userAddress[0],
          false,
        )}</strong>`}
      />

      <ManageContractsAddressFields
        address={terminateLedgerAddress}
        action="terminateLedgerAddress"
        showNameFields={false}
        showSSN={false}
        showMobilePhoneNumber={false}
        disabled={terminateLedgerUseCurrentAddress}
      />
    </section>
  );
};

export default TerminateLedgerAddress;
